/* eslint eqeqeq: 0 */
import Immutable from "immutable";
import * as constants from "../constants/user";
import { CLOSE_POPUP } from "../constants";

const defaultuserSettingsState = new Immutable.Map({
  isOpen: false,
  errors: {},
  fields: new Immutable.Map({}),
  accepted: false
});

export default function userSettings(state = defaultuserSettingsState, action) {
  if (action.type == constants.OPEN_USER_SETTINGS) {
    return state.set("isOpen", true);
  }
  if (action.type == CLOSE_POPUP) {
    return state.merge({ isOpen: false, errors: {} });
  }
  if (action.type == constants.SET_USER_SETTINGS_FIELD) {
    if (action.payload.warn_balance != undefined) {
      if (action.payload.warn_balance == "") {
        // eslint-disable-next-line no-param-reassign
        action.payload.send_notifications = false;
      } else {
        // eslint-disable-next-line no-param-reassign
        action.payload.send_notifications = true;
      }
    }

    if (action.path == ["checking_account_recipient"]) {
      const checking = state.getIn(["fields", "checking_account_recipient"]);
      const newChecking = Object.assign({}, checking, action.payload);
      return state.setIn(["fields", "checking_account_recipient"], newChecking);
    }
    return state.mergeIn(["fields"], action.payload);
  }
  if (action.type == constants.ON_UPDATE_USER_SETTINGS_FAILED) {
    return state.set("errors", action.errors);
  }
  if (action.type == constants.ON_LOAD_USER_SETTINGS) {
    if (!!action.data.wmr) {
      action.data.wmrDisabled = true;
    }

    action.data.initialAccepted = action.data.offer_accepted;

    return state.set("fields", new Immutable.Map(action.data));
  }
  return state;
}
